export class Currency {
  symbol: string = '';
  currency: string = '';
}
